import {
  dlTrackFilterSelecting,
  dlTrackProductsReceive,
  dlViewPLPOrSRPItemList,
} from 'app/analytics/productListAnalytics';
import { CLEAR_FILTERS, SELECT_FILTER } from './facetsListConstants';
import { fetchProducts } from '../productList/productListActions';
import { getFacetNameEn } from './availableFacetsReducer';
import { getTotalItems } from '../../productsReducer';

export const clearFilters = () => ({
  type: CLEAR_FILTERS,
});

export const selectFilter = (filterName, filterItem) => dispatch => {
  return dispatch({
    type: SELECT_FILTER,
    filterName,
    filterItem,
  });
};

export const selectFacet = (facetId, facetValueId) => dispatch => {
  return dispatch({
    type: 'SELECT_FACET',
    facetId,
    facetValueId,
  });
};

export const removeFacetItem = item => (dispatch, getState) => {
  dispatch({
    type: 'FACET_ITEM_REMOVED',
    item,
  });
  return dispatch(fetchProducts({ showLoader: true })).then(json => {
    const state = getState();
    dlTrackFilterSelecting({
      facetHeaderName: getFacetNameEn(state.filters.available, item.facet),
      facetItemId: item.id,
      totalItems: getTotalItems(state),
      isSelected: false,
    });
    dlTrackProductsReceive(json.products, json.searchMetadata.totalItems);
    dlViewPLPOrSRPItemList(json.products);
  });
};

export const applyFacetItem = item => (dispatch, getState) => {
  dispatch({
    type: 'FACET_ITEM_APPLIED',
    item,
  });
  return dispatch(fetchProducts({ showLoader: true })).then(json => {
    const state = getState();
    dlTrackFilterSelecting({
      facetHeaderName: getFacetNameEn(state.filters.available, item.facet),
      facetItemId: item.id,
      totalItems: getTotalItems(state),
      isSelected: true,
    });
    dlTrackProductsReceive(json.products, json.searchMetadata.totalItems);
    dlViewPLPOrSRPItemList(json.products);
  });
};

export const removeAllFacets = () => dispatch => {
  dispatch({
    type: 'ALL_FACETS_REMOVED',
  });
  return dispatch(fetchProducts({ showLoader: true, withAnalytics: false }));
};
